import React, { useState } from "react";
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Menu,
  MenuItem,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  Menu as MenuIcon,
  Language as LanguageIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const colors = {
  darkGreen: "#1B5E20",
  mediumGreen: "#2E7D32",
  lightGreen: "#4CAF50",
  paleGreen: "#E8F5E9",
  darkOrange: "#E65100",
  lightOrange: "#FF9800",
  white: "#FFFFFF",
  darkText: "#1a1a1a",
  subText: "#4a4a4a",
};

export default function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  
  // State for Main Mobile Menu (Hamburger)
  const [mobileMenu, setMobileMenu] = useState(null);
  
  // State for Login Sub-Menu
  const [loginMenu, setLoginMenu] = useState(null);

  // State for Language Menu (New)
  const [langMenu, setLangMenu] = useState(null);
  const getSavedLangLabel = () => {
    const savedKey = localStorage.getItem("appLanguage");
    return savedKey === "ta" ? "தமிழ்" : "English";
  };
  const [currentLang, setCurrentLang] = useState(getSavedLangLabel());

  const handleMobileMenuOpen = (event) => {
    setMobileMenu(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenu(null);
  };

  const handleLoginMenuOpen = (event) => {
    setLoginMenu(event.currentTarget);
  };

  const handleLoginMenuClose = () => {
    setLoginMenu(null);
  };

  // Language Handlers
  const handleLangMenuOpen = (event) => {
    setLangMenu(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangMenu(null);
  };
const {i18n} = useTranslation()
  const handleLanguageChange = (lang,key) => {
    setCurrentLang(lang);
     i18n.changeLanguage(key);
     localStorage.setItem("appLanguage", key);
    handleLangMenuClose();
    
    
  };

//   const navItems = [
//     { label: "Home", path: "/Home" },
//     { label: "About Us", path: "/about" },
//     { label: "Scheme", path: "/schemes" },
//     { label: "Contact", path: "/contact" },
//   ];
 const { t } = useTranslation();
  const navItems = t("nav", { returnObjects: true });

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: colors.white,
        borderBottom: `2px solid ${colors.paleGreen}`,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        position: "sticky",
        top: 0,
        zIndex: 1100,
      }}
    >
      {/* Top Bar Section */}
      <Container maxWidth="xl" sx={{ py: { xs: 1, md: 1.5 }, position: "relative" }}>
        
        {/* Mobile Hamburger Menu - Absolute Top Right */}
        {isMobile && (
          <Box 
            sx={{ 
              position: "absolute", 
              top: "50%", 
              right: 0, 
              transform: "translateY(-50%)",
              zIndex: 1200 
            }}
          >
            <Button 
              onClick={handleMobileMenuOpen} 
              sx={{ color: colors.darkGreen, minWidth: "auto", p: 1 }}
            >
              <MenuIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
        )}

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          
          {/* Left Side Text */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: { xs: "flex-end", md: "flex-end" }, pr: { xs: 1, md: 4 }, borderRight: { xs: "none", md: `1px solid ${colors.paleGreen}` }, mr: { xs: 1, md: 0 } }}>
            <Typography sx={{ fontWeight: 800, color: colors.darkGreen, fontSize: { xs: "0.9rem", md: "1.1rem" }, lineHeight: 1.2 }}>TN Agroforestry</Typography>
            <Typography sx={{ fontWeight: 500, color: colors.darkText, fontSize: { xs: "0.7rem", md: "0.8rem" }, lineHeight: 1.3 }}>Government of Tamil Nadu</Typography>
            <Typography sx={{ fontWeight: 500, color: colors.subText, fontSize: { xs: "0.65rem", md: "0.75rem" }, lineHeight: 1.3 }}>Department of Agriculture - Farmers Welfare</Typography>
          </Box>

          {/* Center Logo */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", px: { xs: 1, md: 4 }, flexShrink: 0 }}>
            <Box sx={{ width: { xs: 50, md: 70 }, height: { xs: 50, md: 70 }, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
             <img src="/TN.png" alt="TN Gov Logo" style={{ width: "100%", height: "100%", objectFit: 'contain' }} />
            </Box>
          </Box>

          {/* Right Side Text */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: { xs: "flex-start", md: "flex-start" }, pl: { xs: 1, md: 4 }, borderLeft: { xs: "none", md: `1px solid ${colors.paleGreen}` }, ml: { xs: 1, md: 0 } }}>
            <Typography sx={{ fontWeight: 800, color: colors.darkGreen, fontSize: { xs: "0.9rem", md: "1.1rem" }, lineHeight: 1.2, fontFamily: "'Noto Sans Tamil', sans-serif" }}>தமிழ்நாடு வேளாண் காடுகள்</Typography>
            <Typography sx={{ fontWeight: 500, color: colors.darkText, fontSize: { xs: "0.7rem", md: "0.8rem" }, lineHeight: 1.3, fontFamily: "'Noto Sans Tamil', sans-serif" }}>தமிழ்நாடு அரசு</Typography>
            <Typography sx={{ fontWeight: 500, color: colors.subText, fontSize: { xs: "0.65rem", md: "0.75rem" }, lineHeight: 1.3, fontFamily: "'Noto Sans Tamil', sans-serif" }}>வேளாண்மை - உழவர் நலத்துறை</Typography>
          </Box>
        </Box>
      </Container>

      {/* Bottom Navigation Menu */}
      <Box sx={{ background: `linear-gradient(90deg, ${colors.darkGreen}, ${colors.mediumGreen})`, py: 0.5 }}>
        <Container maxWidth="xl">
          {isMobile ? (
            <Box></Box>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {/* Left: Navigation Items */}
              <Box sx={{ display: "flex", justifyContent: "center", gap: 1, flex: 1 }}>
                {navItems.map((item) => (
                  <Button 
                    key={item.label} 
                    component={Link} 
                    to={item.path}
                    sx={{ 
                      color: colors.white, 
                      fontWeight: 600, 
                      fontSize: "0.9rem", 
                      borderRadius: 2, 
                      px: 3, 
                      py: 1, 
                      "&:hover": { bgcolor: colors.paleGreen, color: colors.darkGreen } 
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>

              {/* Right: Action Buttons (Login + Language) */}
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                
                {/* Desktop Login Button */}
                <Button 
                  aria-controls="login-menu" 
                  aria-haspopup="true" 
                  onClick={handleLoginMenuOpen} 
                  sx={{ 
                    color: colors.lightOrange, 
                    fontWeight: 700, 
                    fontSize: "0.9rem", 
                    borderRadius: 2, 
                    px: 3, 
                    py: 1, 
                    border: "1px solid rgba(255, 152, 0, 0.5)", 
                    "&:hover": { bgcolor: colors.lightOrange, color: colors.darkGreen } 
                  }} 
                  endIcon={<ExpandMoreIcon />}
                >
                  {t("header.login")}
                </Button>

                {/* Desktop Language Button */}
                <Button
                  aria-controls="lang-menu"
                  aria-haspopup="true"
                  onClick={handleLangMenuOpen}
                  sx={{
                    color: colors.white,
                    fontWeight: 600,
                    fontSize: "0.9rem",
                    borderRadius: 2,
                    px: 2,
                    py: 1,
                    textTransform: "none",
                    minWidth: "auto",
                    "&:hover": { bgcolor: colors.white  }
                  }}
                  startIcon={<LanguageIcon sx={{ fontSize: 20 }} />}
                  endIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
                >
                  {currentLang}
                </Button>

              </Box>
            </Box>
          )}
        </Container>
      </Box>

      {/* MOBILE HAMBURGER MENU */}
      <Menu
        anchorEl={mobileMenu}
        open={Boolean(mobileMenu)}
        onClose={handleMobileMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { width: "250px" } }}
      >
        {navItems.map((item) => (
          <MenuItem 
            key={item.label} 
            component={Link} 
            to={item.path}
            onClick={handleMobileMenuClose}
            sx={{ fontWeight: 500 }}
          >
            {item.label}
          </MenuItem>
        ))}
        
        {/* Mobile Login Trigger Item */}
        <MenuItem 
            onClick={handleLoginMenuOpen} 
            sx={{ fontWeight: 600, color: colors.darkOrange, justifyContent: "space-between" }}
        >
          {t("header.login")}
            <ExpandMoreIcon />
        </MenuItem>
      </Menu>

      {/* LOGIN SUB-MENU */}
      <Menu
        id="login-menu"
        anchorEl={loginMenu}
        open={Boolean(loginMenu)}
        onClose={handleLoginMenuClose}
        anchorOrigin={
            mobileMenu 
            ? { vertical: "top", horizontal: "right" } 
            : { vertical: "bottom", horizontal: "right" }
        }
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ 
          sx: { 
            mt: mobileMenu ? 0 : 1, 
            borderRadius: 2, 
            minWidth: 220, 
            border: `1px solid ${colors.paleGreen}`, 
            boxShadow: `0 4px 20px rgba(27, 94, 32, 0.15)` 
          } 
        }}
      >
        <MenuItem 
          onClick={() => { 
            handleLoginMenuClose(); 
            handleMobileMenuClose(); 
            window.location.href = '/login?role=office'; 
          }} 
          sx={{ py: 1.5, fontWeight: 600, "&:hover": { bgcolor: colors.paleGreen, color: colors.darkGreen } }}
        >
          {t("header.officeLogin")}
        </MenuItem>
        <MenuItem 
          onClick={() => { 
            handleLoginMenuClose(); 
            handleMobileMenuClose(); 
            window.location.href = '/login?role=production'; 
          }} 
          sx={{ py: 1.5, fontWeight: 600, "&:hover": { bgcolor: colors.paleGreen, color: colors.darkGreen } }}
        >
          {t("header.productionLogin")}
        </MenuItem>
        <MenuItem 
          onClick={() => { 
            handleLoginMenuClose(); 
            handleMobileMenuClose(); 
            window.location.href = '/login?role=farmer'; 
          }} 
          sx={{ py: 1.5, fontWeight: 600, "&:hover": { bgcolor: colors.paleGreen, color: colors.darkGreen } }}
        >
          {t("header.farmerLogin")}
        </MenuItem>
      </Menu>

      {/* LANGUAGE SUB-MENU */}
      <Menu
        id="lang-menu"
        anchorEl={langMenu}
        open={Boolean(langMenu)}
        onClose={handleLangMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: 2,
            minWidth: 140,
            border: `1px solid ${colors.paleGreen}`,
            boxShadow: `0 4px 20px rgba(27, 94, 32, 0.15)`
          }
        }}
      >
        <MenuItem 
          onClick={() => handleLanguageChange('English',"en")}
          selected={currentLang === "English"}
          sx={{ "&.Mui-selected": { bgcolor: colors.paleGreen, color: colors.darkGreen, fontWeight: 700 } }}
        >
          English
        </MenuItem>
        <MenuItem 
          onClick={() => handleLanguageChange("தமிழ்","ta")}
          selected={currentLang === "தமிழ்"}
          sx={{ fontFamily: "'Noto Sans Tamil', sans-serif", "&.Mui-selected": { bgcolor: colors.paleGreen, color: colors.darkGreen, fontWeight: 700 } }}
        >
          தமிழ்
        </MenuItem>
      </Menu>

    </Box>
  );
}